<div class="preview-container">
  <div class="modal-inner-container">
    <div class="heading">
      <p>{{campaignData?.name}}</p>
      <h1>{{modalTitle | translate}}</h1>
    </div>
    <div class="details-with-cover" [ngClass]="isLoading ? 'loading' : ''">
      <app-loader *ngIf="isLoading && !isError"></app-loader>
      <ng-container *ngIf="!isLoading && !isError && fullCampaign">
        <div class="cover"><app-information-image [currentCampaign]="fullCampaign"></app-information-image></div>
        <div class="details">
          <div class="details-item">
            <h4 class="item-label">{{ 'view_translations.type_and_provision' | translate}}</h4>
            <app-campaign-type-and-commision [campaign]="fullCampaign"> </app-campaign-type-and-commision>
          </div>
          <div class="details-item device">
            <h4 class="item-label">{{ 'view_translations.device_type' | translate}}</h4>
            <div class="devices-wrapper">
              <div class="device-category" *ngFor="let type of fullCampaign!.device_types">
                <p class="device-type">{{ 'device_types.' + type.id | translate }}</p>
                <p class="colon">:</p>
                <p *ngFor="let child of type.children" class="device-type">{{ 'device_types.' + child.id | translate }}</p>
              </div>
            </div>
          </div>
          <div class="details-item countries">
            <h4 class="item-label">{{ 'view_translations.countries' | translate }}</h4>
            <div class="countries-wrapper">
              <ng-container
                *ngFor="let country of ( fullCampaign.countries | slice : 0 : 6 ); let i = index; trackBy: trackCountry"
                class="d-flex align-items-center">
                <app-categories-or-countries [watchInactive]="true" [item]="country" [index]="i" [mode]="'countries'" [updateDecision]="updateDecision">
                </app-categories-or-countries>
              </ng-container>
              <button (click)="openCountriesModal()" *ngIf="(fullCampaign?.countries?.length ?? 0) > 6" class="btn show-more-button-countries">
                +{{ fullCampaign.countries?.length ?? 6 - 6 }}
              </button>
            </div>
          </div>
          <div class="details-item description">
            <h4 class="item-label">{{ 'view_translations.description' | translate }}</h4>
            <ng-container *ngIf="description; else noData">
              <p [innerHTML]=" description | sanitizeHtml"></p>
            </ng-container>
            <ng-template #noData>
              <p>{{ 'no_data' | t }}</p>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="footer">
      <div class="campaigns-view" *ngIf="viewType === campaignsViewType && !smartlinks">
        <div *ngIf="!isCreatingLocker" class="create-button">
          <app-primary-button
            [icon]="'lock'"
            ngbTooltip="{{ fullCampaign?.access_information ?? '' | translate }}"
            [disabled]="!fullCampaign?.access"
            (click)="onCreateLocker()"
            [buttonText]="'locker_campaign_create'"></app-primary-button>
        </div>
        <div *ngIf="isCreatingLocker" class="choose-locker-wrapper">
          <h4>{{ 'view_translations.locker_campaign_which_locker' | translate }}</h4>
          <div class="buttons-wrapper">
            <app-secondary-button
              (click)="onLockerClick(availableDestinations.cpa_locker)"
              [height]="60"
              [maxWidth]="160"
              [backgroundColor]="'white'"
              [iconSize]="12"
              [icon]="'calendar'"
              [text]="'menu_translations.cpa_locker'"></app-secondary-button>
            <app-secondary-button
              (click)="onLockerClick(availableDestinations.captcha_locker)"
              [height]="60"
              [maxWidth]="160"
              [backgroundColor]="'white'"
              [iconSize]="12"
              [iconWeight]="600"
              [icon]="'check-circle'"
              [text]="'menu_translations.captcha_locker'"></app-secondary-button>
            <app-secondary-button
              (click)="onLockerClick(availableDestinations.file_locker)"
              [height]="60"
              [maxWidth]="160"
              [backgroundColor]="'white'"
              [iconSize]="12"
              [icon]="'file'"
              [text]="'menu_translations.file_locker'"></app-secondary-button>
            <app-secondary-button
              (click)="onLockerClick(availableDestinations.mobile_rewards)"
              [height]="60"
              [maxWidth]="160"
              [backgroundColor]="'white'"
              [iconSize]="12"
              [icon]="'gift-box'"
              [text]="'menu_translations.mobile_rewards'"></app-secondary-button>
          </div>
        </div>
      </div>
      <!--      <div class="close-footer">-->
      <!--        <app-secondary-button class="secondary-btn" [text]="'close'" [largeButton]="false" [backgroundColor]="'$light-grey-color'" (click)="onClose()">-->
      <!--        </app-secondary-button>-->
      <!--      </div>-->
    </div>
  </div>
  <button (click)="onClose()" class="btn close-button">
    <nb-icon class="cross-icon" icon="cross" pack="icomoon"></nb-icon>
  </button>
</div>
